import React, { useEffect, useState } from "react";
import { Download, FileText } from "lucide-react";
import axios from "axios";
import { ORDER_API } from "../../../data/api";

const Invoice = () => {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchInvoices = async () => {
      try {
        const vendorId = localStorage.getItem("vendorId");
        const response = await axios.get(`${ORDER_API.GET_ALL}/vendor/${vendorId}`);
        const data = response.data;

        // Map orders to invoice format
        const invoiceData = data.map(order => ({
          id: order.orderId,
          date: new Date(order.createdAt).toLocaleDateString(),
          amount: `₹${order.finalAmount}`,
          status: order.orderStatus === "Delivered" ? "Paid" : "Pending",
        }));

        setInvoices(invoiceData);
      } catch (error) {
        console.error("Error fetching invoices:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchInvoices();
  }, []);

  if (loading) return <p>Loading invoices...</p>;

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4 flex items-center gap-2">
        <FileText /> Invoice History
      </h1>

      <div className="bg-white shadow rounded-xl p-4">
        <table className="w-full text-left">
          <thead>
            <tr className="border-b">
              <th className="py-3">Invoice ID</th>
              <th className="py-3">Date</th>
              <th className="py-3">Amount</th>
              <th className="py-3">Status</th>
              <th className="py-3 text-right">Action</th>
            </tr>
          </thead>

          <tbody>
            {invoices.length > 0 ? (
              invoices.map((invoice, index) => (
                <tr key={index} className="border-b last:border-none">
                  <td className="py-3 font-medium">{invoice.id}</td>
                  <td className="py-3">{invoice.date}</td>
                  <td className="py-3 font-semibold">{invoice.amount}</td>
                  <td className="py-3">
                    {invoice.status === "Paid" ? (
                      <span className="bg-green-100 text-green-700 px-3 py-1 rounded-full text-sm">
                        Paid
                      </span>
                    ) : (
                      <span className="bg-yellow-100 text-yellow-700 px-3 py-1 rounded-full text-sm">
                        Pending
                      </span>
                    )}
                  </td>
                  <td className="py-3 text-right">
                    <button
                      className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg text-sm"
                      onClick={() => {
                        // Implement invoice download logic here
                        alert(`Downloading invoice ${invoice.id}`);
                      }}
                    >
                      <Download size={16} /> Download
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={5} className="text-center p-6 text-gray-400 italic">
                  No invoices found...
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Invoice;
